import { AccountingCenterMemberFormValues } from '@/services/types/accounting-centers-types';
import { formatBudgetCalculationAmount } from '@/utils/budgetCalculations';

export interface ACMemberCalculations {
  achov: number;
  currency: string;
}

/**
 * Accounting Center Hours Operative Value (ACHOV)
 * = sum of (ore hours * hourly rate) across all members.
 */
export const getACMemberCalculations = (
  members: AccountingCenterMemberFormValues[] = [],
  currency = 'EUR'
): ACMemberCalculations => {
  const achov = members.reduce((sum, member) => {
    const oreHours = Number(member.oreHours) || 0;
    const hourlyRate = Number(member.hourlyRate) || 0;
    return sum + oreHours * hourlyRate;
  }, 0);

  return { achov, currency };
};

export const formatACHOV = (amount: number, currency: string): string =>
  formatBudgetCalculationAmount(amount, currency);
